import React from 'react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './MainSwiper.css';

const MainSwiper = ({ slides }) => {
  
  return (
    <div id='main-swiper-wrap' className='inner-container'>
      <Swiper
        slidesPerView={1}
        initialSlide={0}
        centeredSlides={true}
        rewind={true}
        loop={false}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mainSwiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className='swiper-content'>
              <div className='font-white swiper-text'>
                <div className='swiper-title-text'>{slide.title}</div>
                {slide.text && <div>{slide.text}</div>}
              </div>
              <div>
                {slide.image && (
                  <img src={slide.image} alt={`메인이미지${index + 1}`} />
                )}
                
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default MainSwiper;
